export { SysqueProgressBarModule } from './sysque-progress-bar.module';
export { SysqueProgressBarComponent } from './sysque-progress-bar.component';